import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../utils/auth';
import Button from 'react-bootstrap/Button';
import '../styles/signIn.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons';
import Spinner from 'react-bootstrap/Spinner';

const SignIn = () => {
  const [memberId, setMemberId] = useState('');
  const [password, setPassword] = useState('');
  const { authInfo, handleLogin } = useAuth();
  const [loading, setLoading] = useState(false);


  const handleSignIn = async (event) => {
  event.preventDefault(); // 이거 추가!

  if (loading) return; // 중복 클릭 방지

  setLoading(true); // ✅ 로딩 시작
  try {
    const response = await axios.post('/member/signIn', {
      memberId,
      password,
    });
    handleLogin(response);
  } catch (error) {
    const message =
      error.response?.data || '로그인이 실패했습니다. 아이디와 비밀번호를 확인해주세요';
    alert(message);
    console.error('로그인 실패:', message);
  } finally {
    setLoading(false); // 🔥 로딩 종료 (성공/실패 상관없이)
  }
};

  return (
    <div className="container">
      <div className='inner'>
        <div className='content'>
          <form onSubmit={handleSignIn}>
            <div className='form-content'>
              <div className='form-list'>
                <h1>로그인</h1>
                <div className='formId'>
                  <div className='id-icon'><FontAwesomeIcon icon={faUser} /></div>
                  <div className='id'>
                    <input type='text' placeholder='아이디' className='input-id'
                      value={memberId}
                      onChange={(e) => setMemberId(e.target.value)}></input>
                  </div>
                </div>
                <div className='formPw'>
                  <div className='pw-icon'><FontAwesomeIcon icon={faLock} /></div>
                  <div className='pw'>
                    <input type='password' placeholder='비밀번호' className='input-pw'
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}></input>
                  </div>
                </div>
              </div>
            </div>
            <Button
              variant="success"
              className="frm-btn"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{' '}
                  로그인 중...
                </>
              ) : (
                '로그인'
              )}
            </Button>
          </form>

          {/* 토큰 및 사용자 정보가 존재하면 환영 메시지 표시 */}
          {authInfo && authInfo.user && (
            <div>
              <p>{`로그인한 ${authInfo.user.username} 환영합니다!`}</p>
              <p>{`이메일: ${authInfo.user.email}`}</p>
              {/* 여기에 토큰을 활용한 다른 정보를 표시할 수 있습니다. */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignIn;
